(function(angular){
	'use strict';
	
	var planFeaturedAssetObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			planName: '@'
		},
		controller: [
			'$rootScope',
			'ReitElementFactory',
			'STATIC_BASE_PATH', 
			PlanFeaturedAssetFunction
		],
		controllerAs: 'planFeaturedAsset'
	};
	
	angular
		.module('viewPlanModule')
		.component('planFeaturedAsset', planFeaturedAssetObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-featured-asset.html';
	}
	
	function PlanFeaturedAssetFunction(
		$rootScope,
		ReitElementFactory,
		STATIC_BASE_PATH){
		var planFeaturedAsset = this;
		var featuredMetaByPlan = {
			'Supplemental Income' : {
				bgImg: STATIC_BASE_PATH + '/images/marketing/ria/real-assets-bg-lg.jpg',
				headline: 'A luxury retail and apartment building on Washington, DC&rsquo;s high-end shopping and nightlife&nbsp;corridor',
				imgs: [
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-elysium-14-1.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-elysium-14-2.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-elysium-14-3.jpg'
				],
				reitElementId: 24
			},
			'Balanced Investing' : {
				bgImg: STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-bg-revolve-craft.jpg',
				headline: 'Newly-constructed boutique apartments in downtown Seattle near the Amazon&nbsp;campus',
				imgs: [
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-revolve-craft-1.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-revolve-craft-2.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-revolve-craft-3.jpg',
				],
				reitElementId: 29
			},
			'Long-Term Growth' : {
				bgImg: STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-bg-haven-mt-vernon.jpg',
				headline: 'Apartment renovation and hold near new Amazon headquarters in Northern Virginia',
				imgs: [
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-haven-mt-vernon-1.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-haven-mt-vernon-2.jpg',
					STATIC_BASE_PATH + '/images/marketing/ria/plan-featured-asset-haven-mt-vernon-3.jpg'
				],
				reitElementId: 15
			}
		};

		function initAsset() {
			planFeaturedAsset.asset = featuredMetaByPlan[planFeaturedAsset.planName];

			ReitElementFactory.getReitElement(planFeaturedAsset.asset.reitElementId).then(
				function(reitElement) {
					angular.extend(planFeaturedAsset.asset, reitElement);
				}
			);

			if(planFeaturedAsset.planName === 'Balanced Investing') {
				planFeaturedAsset.darkText = false;
			} else {
				planFeaturedAsset.darkText = true;
			}
		}

		planFeaturedAsset.$onInit = function() {
			initAsset();
		};

		planFeaturedAsset.openModal = function() {
			$rootScope.ModalFactory.openReitElement({
				reitElement: planFeaturedAsset.asset
			});
		};
	}
})(window.angular);